import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Layout
import Layout from "@/components/common/Layout";

// Pages
import Dashboard from "@/pages/Dashboard";
import InsightsPage from "@/pages/InsightsPage";
import RulesList from "@/pages/RulesList";
import StateLaws from "@/pages/StateLaws";
import UploadConfigurations from "@/pages/UploadConfigurations";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/rules" element={<RulesList />} />
            <Route path="/state-laws" element={<StateLaws />} />
            <Route path="/upload" element={<UploadConfigurations />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
